import React from "react";
import Hero from "./components/Hero";

function App() {
  return (
    <div className="bg-gradient-to-r from-black to-blue-900 flex flex-col font-body scroll-smooth min-h-screen h-screen ">
      <Hero />
    </div>
  );
}

export default App;
